define('viewmodels/modals/dialogs/CookieDialog',[],function () {

    function CookieDialog(dialog, getField) {
        this.dialog = dialog;
        this.content = getField('content');
        this.title = getField('title');
    }

    CookieDialog.prototype.show = function() {
        return this.dialog.showDialog(this);
    };

    CookieDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return CookieDialog;
});

